import { useNavigate } from "react-router-dom";
import usePageMeta from "../hooks/usePageMeta";

export default function Help() {
  usePageMeta("Help");
  const navigate = useNavigate();

  return (
    <div className="h-screen bg-gray-50 flex items-center justify-center p-3 overflow-hidden">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-4">
        <h1 className="text-xl font-bold text-center mb-4">
          I need help
        </h1>

        {/* Help Content */}
        <div className="mb-4 text-center">
          <p className="text-gray-700 mb-3 text-sm">
            Please call the scheduling team at:
          </p>
          
          <a
            href="tel:+14167483982"
            className="text-2xl font-bold text-[#DC1F00] hover:text-[#b91900] transition-colors"
          >
            (416)-748-3982
          </a>
          
          <p className="text-gray-600 mt-4 text-xs">
            And we will get it sorted with you. Please prepare to provide us your shift details (e.g. time, location and position.)
          </p>
        </div>

        {/* Button */}
        <button
          onClick={() => navigate("/checkin" + window.location.search)}
          className="w-full bg-[#DC1F00] text-white py-3 px-4 rounded-lg font-semibold text-base hover:bg-[#b91900] transition-colors"
        >
          DONE
        </button>
      </div>
    </div>
  );
}
